import CustomerService from '@/services/customers-service';
import pageKeyNames from '@/utils/page-key-names';
import AuthorizationManager from '@/authorization/authorization-manager.js';

export default {
	props: {
		customerId: String
	},
	computed: {
		actions() {
			const { customerId } = this.$route.params;
			return [
				{
					id: 1,
					action: this.vueLoginByPass,
					disabled: false,
					iconClass: 'icon icon-vue',
					label: 'VUE',
					title: 'Select to go to the home page',
					type: 'anchor',
					visible: this.hasCustomerUpdatePermission,
					loggingParams: {
						event: 'click',
						target: 'Vue Login Bypass',
						eventData: this.customerData
					}
				},
				{
					id: 2,
					action: {
						path: `/clients/${this.customerData?.customerId}/companies`
					},
					disabled: true,
					iconClass: 'icon icon-manage',
					label: 'Settings',
					title: 'Select to go to the default settings',
					type: 'route-link',
					visible: false /* visible: this.hasCustomerDefaultSettingPermission,*/,
					loggingParams: {
						event: 'click',
						target: 'Vue Login Bypass',
						eventData: this.customerData
					}
				},
				{
					id: 3,
					action: {
						path: `/clients/${customerId ||
							this.customerData.customerId}/forms`,
						activePage: pageKeyNames.FORM
					},
					disabled: false,
					iconClass: 'icon icon-document',
					label: 'Forms',
					title: 'Select to go to the form page',
					type: 'route-link',
					visible: this.hasReadPermission,
					loggingParams: {
						event: 'click',
						target: 'Go to Form Page',
						eventData: this.customerData
					}
				},
				{
					id: 4,
					action: '#',
					disabled: true,
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to the transactions page',
					type: 'route-link',
					visible: false /* visible: this.hasTransactionsPermission,*/,
					loggingParams: {
						event: 'click',
						target: 'Go to Transactions Page',
						eventData: this.customerData
					}
				},
				{
					id: 5,
					action: {
						path: this.formatErrorLogPath,
						activePage: pageKeyNames.CUSTOMER_ERROR_LOGS
					},
					disabled: false,
					iconClass: 'icon icon-error',
					label: 'Error Log',
					title: 'Select to go to the Error Log page',
					type: 'route-link',
					visible: this.hasCustomerErrorLogPermission,
					loggingParams: {
						event: 'click',
						target: 'Go to Error Log Page',
						eventData: this.customerData
					}
				},
				{
					id: 666,
					action: '#',
					disabled: false,
					iconClass: 'icon icon-menu',
					label: 'More',
					title: 'select to see the more actions',
					type: 'dropdown',
					visible: false /* visible: this.hasReadPermission, */,
					items: [
						{
							id: 6,
							action: {
								path: `/clients/${customerId ||
									this.customerData.customerId}/forms`,
								activePage: pageKeyNames.FORM
							},
							disabled: false,
							iconClass: 'icon icon-document',
							label: 'Forms',
							title: 'Select to go to the form page',
							type: 'route-link',
							visible: this.hasReadPermission,
							loggingParams: {
								event: 'click',
								target: 'Go to Form Page',
								eventData: this.customerData
							}
						}
					],
					loggingParams: {
						event: 'click',
						target: 'More Button',
						eventData: this.customerData
					}
				}
			];
		},
		customerData() {
			const user = this.$store.getters['oidcStore/oidcUser'];
			const params = {
				customerId: this.customer?.id,
				userId: user.sub,
				email: user.Email,
				companyId: this.company?.companyId || null
			};

			if (this.$options.name === 'CompanyCard') {
				params.cid = this.company?.companyId;
			}
			if (this.$options.name === 'LocationCard') {
				params.cid = this.location.companyLocationId;
				params.locationId = this.location?.companyLocationId;
			}

			return params;
		},
		// DEV NOTE: WIP. ASK PRODUCT
		settingsPath() {
			switch (this.$options.name) {
				case 'CompanyCard':
					return {
						path: `/clients/${this.customerData?.customerId}/companies/${this.company?.companyCode}`
					};
				case 'LocationCard':
					return {
						path: `/clients/${this.customerData?.customerId}/companies/${this.company?.companyCode}`
					};
				default:
					// TODO: Customer settings
					return {
						path: '#'
					};
			}
		},
		hasCustomerDefaultSettingPermission() {
			return this.authorize(['clients.read']);
		},
		hasCustomerErrorLogPermission() {
			return this.authorize(['clients.read', 'errorLogs.read']);
		},
		hasTransactionsPermission() {
			return this.authorize(['transactions.read']);
		},
		hasReadPermission() {
			return this.authorize(['forms.read']);
		},
		hasCustomerUpdatePermission() {
			const authorization = {
				permissions: ['clients.update']
			};
			return AuthorizationManager.validate(authorization);
		},
		formatErrorLogPath() {
			const { customerData, company, location, $options } = this;

			const companyId =
				parseInt(customerData?.companyId) || company?.companyId;
			const locationId =
				parseInt(customerData?.locationId) ||
				location?.companyLocationId;

			let path = `/clients/${customerData?.customerId}`;

			if (($options.name === 'LocationCard' || location) && company) {
				return `${path}/company/${companyId}/location/${locationId}/error-logs`;
			}

			if (($options.name === 'CompanyCard' || company) && !location) {
				return `${path}/company/${companyId}/error-logs`;
			}

			return `${path}/error-logs`;
		}
	},
	methods: {
		async vueLoginByPass(e) {
			if (e) e.preventDefault();
			const self = this;
			await CustomerService.VueLoginBypass(self.customerData)
				.then(response => {
					if (response && response.bypassUrl) {
						const url = this.customerData.cid
							? `${response.bypassUrl}&cid=${this.customerData.cid}`
							: `${response.bypassUrl}`;
						window.open(url, '_blank');
					}
				})
				.catch(error => {
					let status = 0;
					error ? (status = 400) : status;
					self.updateToast({ status: status, message: error });
				});
		},
		updateToast(val) {
			this.$store.dispatch('toastMessages/show', {
				toastId: 'clients.action',
				statusCode: val.status,
				message: val.message,
				slot: 'default',
				useIcon: true,
				userDismissable: true
			});
		},
		getAuthorization(permissions) {
			const authorization = {
				permissions,
				policies: ['InternalSupportTech']
			};
			return authorization;
		},
		authorize(permissions) {
			const authorization = this.getAuthorization(permissions);
			return AuthorizationManager.validate(authorization);
		}
	}
};
